export default "__VITE_ASSET__CWj4LugN__"